import { ref } from 'vue';

export function useHorizontalScrollInteractions() {
  const DRAG_THRESHOLD = 4;
  const isDragging = ref(false);
  let pointerId = null;
  let initialScrollLeft = 0;
  let startX = 0;

  const endDrag = event => {
    if (event.pointerId !== pointerId) return;

    if (isDragging.value) {
      event.currentTarget.releasePointerCapture?.(pointerId);
    }
    isDragging.value = false;
    pointerId = null;
  };

  const onPointerDown = event => {
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    if (event.pointerType && event.pointerType !== 'mouse') return;

    pointerId = event.pointerId;
    startX = event.pageX;
    initialScrollLeft = event.currentTarget.scrollLeft;
  };

  const onPointerMove = event => {
    if (event.pointerId !== pointerId) return;
    if (!isDragging.value && Math.abs(event.pageX - startX) < DRAG_THRESHOLD)
      return;

    if (!isDragging.value) {
      isDragging.value = true;
      event.currentTarget.setPointerCapture?.(pointerId);
    }

    event.preventDefault();
    event.currentTarget.scrollLeft = initialScrollLeft - (event.pageX - startX);
  };

  const onWheel = event => {
    const track = event.currentTarget;
    if (track.scrollWidth <= track.clientWidth || !event.deltaY) return;

    event.preventDefault();
    track.scrollLeft += event.deltaY;
  };

  return {
    endDrag,
    isDragging,
    onPointerDown,
    onPointerMove,
    onWheel,
  };
}
